import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001/api';

const STATUS_MAP = {
  completed: '完成', failed: '失败', pending: '等待', processing: '处理中'
};

function AdminOverview() {
  const { session } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/admin/dashboard/overview`, {
          headers: { 'Authorization': `Bearer ${session.access_token}` }
        });
        const result = await res.json();
        if (result.success) setData(result.data);
        else setError(result.error);
      } catch (e) { setError('加载失败'); }
      finally { setLoading(false); }
    };
    if (session) fetchData();
  }, [session]);

  if (loading) return <div className="ad-loading">加载中...</div>;
  if (error) return <div className="ad-error">{error}</div>;
  if (!data) return null;

  const fmt = (n) => typeof n === 'number' ? n.toLocaleString() : n;
  const fmtMoney = (n) => `¥${(n || 0).toFixed(2)}`;
  const fmtTime = (t) => new Date(t).toLocaleString('zh-CN', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

  return (
    <div>
      {/* 统计卡片 */}
      <div className="ad-stats-grid">
        <div className="ad-stat-card">
          <div className="ad-stat-label">总用户数</div>
          <div className="ad-stat-value">{fmt(data.totalUsers)}</div>
          <div className="ad-stat-sub">今日 +{data.todayUsers} · 本周 +{data.weekUsers}</div>
        </div>
        <div className="ad-stat-card">
          <div className="ad-stat-label">今日收入</div>
          <div className="ad-stat-value ad-stat-value--green">{fmtMoney(data.todayRevenue)}</div>
          <div className="ad-stat-sub">本周 {fmtMoney(data.weekRevenue)} · 本月 {fmtMoney(data.monthRevenue)}</div>
        </div>
        <div className="ad-stat-card">
          <div className="ad-stat-label">活跃任务</div>
          <div className="ad-stat-value">{fmt(data.activeTasks)}</div>
          <div className="ad-stat-sub">总计 {fmt(data.totalTasks)} 个任务</div>
        </div>
        <div className="ad-stat-card">
          <div className="ad-stat-label">平台余额</div>
          <div className="ad-stat-value">{fmtMoney(data.totalBalance)}</div>
          <div className="ad-stat-sub">冻结 {fmtMoney(data.totalFrozen)}</div>
        </div>
      </div>

      {/* 任务成功率 */}
      <div className="ad-term">
        <div className="ad-term-bar">
          <div className="ad-term-dots">
            <span className="ad-term-dot ad-term-dot--red" />
            <span className="ad-term-dot ad-term-dot--yellow" />
            <span className="ad-term-dot ad-term-dot--green" />
          </div>
          <span className="ad-term-title">task_metrics</span>
        </div>
        <div className="ad-term-body">
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-dim)' }}>
              成功率: {data.successRate}%
            </span>
            <span style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--text-3)' }}>
              {fmt(data.completedTasks)} 完成 / {fmt(data.failedTasks)} 失败
            </span>
          </div>
          <div className="ad-progress">
            <div className="ad-progress-bar ad-progress-bar--green" style={{ width: `${data.successRate}%` }} />
          </div>
          <div style={{ display: 'flex', gap: 24, marginTop: 16 }}>
            <div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-3)', marginBottom: 4 }}>总收入</div>
              <div style={{ fontFamily: 'var(--font-mono)', fontSize: 16, fontWeight: 700, color: 'var(--green)' }}>{fmtMoney(data.totalRevenue)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 最近任务动态 */}
      <div className="ad-term">
        <div className="ad-term-bar">
          <div className="ad-term-dots">
            <span className="ad-term-dot ad-term-dot--red" />
            <span className="ad-term-dot ad-term-dot--yellow" />
            <span className="ad-term-dot ad-term-dot--green" />
          </div>
          <span className="ad-term-title">recent_tasks</span>
        </div>
        <div className="ad-term-body">
          {data.recentTasks.length === 0 ? (
            <div className="ad-empty">暂无任务</div>
          ) : (
            <div className="ad-table-wrap">
              <table className="ad-table">
                <thead>
                  <tr>
                    <th>时间</th>
                    <th>用户</th>
                    <th>类型</th>
                    <th>状态</th>
                    <th>费用</th>
                    <th>语言</th>
                  </tr>
                </thead>
                <tbody>
                  {data.recentTasks.map(t => (
                    <tr key={t.id}>
                      <td>{fmtTime(t.created_at)}</td>
                      <td>{t.user_email || t.user_id?.substring(0, 8)}</td>
                      <td>{t.character_count ? 'SRT' : '音频'}</td>
                      <td><span className={`ad-badge ad-badge--${t.status}`}>{STATUS_MAP[t.status] || t.status}</span></td>
                      <td>{t.cost != null ? fmtMoney(parseFloat(t.cost)) : '-'}</td>
                      <td>{t.target_language || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminOverview;
